// src/components/products/productsData.js
import Iimg1 from '../../images/products/erp.webp';
import Iimg2 from '../../images/products/crm.webp';
// import Iimg3 from '../../images/products/e-learn.jpg';
// import Iimg4 from '../../images/products/cargo.jpg';

import iIimg1 from '../../images/products/icons/1.svg';
import iIimg2 from '../../images/products/icons/2.svg';
// import iIimg3 from '../../images/products/icons/3.svg';
// import iIimg4 from '../../images/products/icons/4.svg';








const ProductsData = [
 
{
  Id: '01',
  sSImg: Iimg1,
  sImg:iIimg1,
  title: 'ERP System',
  slug: 'erp',
  description: 'Streamline and automate your business operations with a powerful and integrated ERP solution.',
  content: ` 
  <p><strong>ThinkBig ERP</strong> is a comprehensive Enterprise Resource Planning platform that unifies your business operations including finance, HR, inventory, sales and production into a single, streamlined system. Designed for efficiency, scalability and analytics, it centralizes your data to enhance decision making, reduce costs and drive organizational growth.</p>
   

    <h4>Product Overview</h4>
    <p><strong>Product Name:</strong> ThinkBig ERP<br/>
    <strong>Technologies:</strong> PHP, JavaScript, SQL<br/>
    <strong>Database Server:</strong> MySQL</p>
<p><strong>THINKBIG INFOTECH</strong> offers enterprise-grade ERP solutions tailored to your business needs, empowering teams with real-time data, smart workflows, and seamless department-wide integration.</p> <p>Our ERP systems are designed to streamline operations, reduce manual effort, and ensure accurate, up-to-the-minute insights across every function. With a user-friendly interface and customizable modules. </p>
   
 
    <h4>Key Features</h4>
    <ul>
      <li>Finance and Accounting Management</li>
      <li>Inventory and Supply Chain Automation</li>
      <li>Human Resource and Payroll Modules</li>
      <li>Sales, Purchase and CRM Integration</li>
      <li>Dynamic Reports and Custom Dashboards</li>
      <li>Role-Based Access and Permissions</li>
      <li>Available in Cloud or On-Premise Models</li>
    </ul>

   
  `
},

{
  Id: '02',
  sSImg: Iimg2,
  sImg:iIimg2,
  title: 'CRM Platform',
  slug: 'crm',
  description:  'A smart CRM solution to boost your customer engagement, sales pipeline and support operations.',
  content: ` <p><strong>ThinkBig CRM</strong> is a comprehensive Customer Relationship Management system that streamlines operations such as lead tracking, contract management, communication and customer support. It integrates multiple channels like email, SMS and third-party platforms  to create a unified customer engagement ecosystem. With powerful automation and reporting tools, it boosts sales productivity, reduces acquisition costs and drives customer retention.</p>
  

    <h4>Product Overview</h4>
    <p><strong>Product Name:</strong> ThinkBig CRM<br/>
    <strong>Technologies:</strong> PHP, JavaScript, SQL<br/>
    <strong>Database Server:</strong> MySQL</p>

   
 <p><strong>THINKBIG INFOTECH</strong> develops intuitive and scalable CRM platforms tailored to modern business needs, helping teams efficiently manage leads, engage customers, and automate key processes across the customer lifecycle.</p> <p>Our CRM solutions are built to drive meaningful interactions, boost conversion rates, and enhance customer satisfaction through personalized communication. With real-time analytics and seamless integrations.</p>
    <h4>Key Features</h4>
    <ul>
      <li>Lead and Contact Management</li>
      <li>Sales Pipeline and Deal Tracking</li>
      <li>Email and SMS Campaign Integration</li>
      <li>Support Ticketing System</li>
      <li>Contract and Document Management</li>
      <li>Performance Dashboards and KPIs</li>
      <li>Custom Workflow Automation</li>
      <li>Third-party Integrations </li>
    </ul>

   
  `
},

//  {
//   Id: '03',
//    sSImg: Iimg3,
//    sImg:iIimg3,
//   title: 'E-Learning Platform',
//   slug: 'elearning',
  
//   description: 'Interactive, scalable, and engaging e-learning solutions for institutions, training providers and corporate L&D teams.',
//   content: `<p><strong>ThinkBig E-Class</strong> is a virtual learning platform designed to simplify course management and enhance learner engagement. It enables instructors to create and manage courses, conduct assessments, track learner progress, and issue certifications  all within an intuitive interface. Students benefit from flexible access, interactive lessons, discussions and real-time feedback.</p>
   
//     <h4>Product Overview</h4>
//     <p><strong>Product Name:</strong> ThinkBig E-Class<br/>
//     <strong>Technologies:</strong> PHP, JavaScript, SQL<br/>
//     <strong>Database Server:</strong> MySQL</p>

    
// <p><strong>THINKBIG INFOTECH</strong> provides powerful and user-friendly E-Learning platforms that transform digital education through immersive experiences, intelligent tracking, and streamlined content delivery.</p> <p>Our solutions are designed to engage learners with interactive modules, personalized learning paths, and real-time performance analytics. Educators can effortlessly manage courses, assessments and certifications  all from a centralized dashboard. </p>

//     <h4>Key Features</h4>
//     <ul>
//       <li>Custom LMS Development</li>
//       <li>Interactive Content and Video Integration</li>
//       <li>Gamification and Progress Tracking</li>
//       <li>Multi-device Accessibility</li>
//       <li>Instructor and Admin Dashboards with Analytics</li>
//       <li>White-labeling and Custom Branding</li>
//     </ul>
// `
// },

// {
//   Id: '04',
//    sSImg: Iimg4,
//    sImg:iIimg4,
//   title: 'Cargo Management System',
//   slug: 'cargo',
//   description: 'A smart logistics solution for efficient cargo tracking, shipment planning, and end-to-end freight lifecycle management.',
//   content: ` <p><strong>ThinkBig Cargo</strong> is a complete cargo and freight management platform that helps logistics companies, freight forwarders and warehouse operators handle their entire shipping lifecycle. The system supports real-time tracking, documentation, fleet coordination, inventory control and automated billing all within a centralized dashboard for operational efficiency and cost savings.</p>
    

//     <h4>Product Overview</h4>
//     <p><strong>Product Name:</strong> ThinkBig Cargo<br/>
//     <strong>Technologies:</strong> PHP, JavaScript, SQL<br/>
//     <strong>Database Server:</strong> MySQL</p>
// <p><strong>THINKBIG INFOTECH</strong> delivers a robust Cargo Management System designed to optimize logistics workflows, improve shipment visibility, and streamline operations across warehousing, transportation, and compliance.</p> <p>Our intelligent system ensures end-to-end tracking, real-time status updates, and accurate documentation to minimize delays and reduce operational costs. With customizable modules and seamless integrations, logistics providers can adapt quickly to changing demands and regulatory requirements.</p>
//     <h4>Key Features</h4>
//     <ul>
//       <li>Real-time Shipment Tracking</li>
//       <li>Freight Booking and Scheduling</li>
//       <li>Warehouse and Inventory Synchronization</li>
//       <li>Route Optimization and ETA Calculation</li>
//       <li>Customs and Compliance Documentation</li>
//       <li>Customer Portal with Notifications</li>
//       <li>Automated Billing and Delivery Reports</li>
//       <li>Fleet and Driver Management</li>
//     </ul>

   
//   `
// },






    
];

export default ProductsData;
